import Vue from "vue";
/**
 * simple Vue instance to emit and listen events 
 * 
 * Emit event:
 * EventBus.$emit('message', payload)
 * 
 * Listen to event:
 * EventBus.$on('message', callback)
 * 
 * Remove listener
 * EventBus.$off('message', callback)
 */
export const EventBus = new Vue()